/*
* Created by Rishabh Kumar on 21/09/20
* */

import * as React from "react"
import {isEmpty as _isEmpty, map as _map} from "lodash"

interface IFlatList {
    listItems: any[],
    renderItem: (params: {item: any, index: number}) => any,
    listEmptyComponent?: any,
    commonProps?: any
}

const FlatList = (props: IFlatList) => {
    if (_isEmpty(props.listItems)) return props.listEmptyComponent
        ? React.cloneElement(props.listEmptyComponent)
        : <div>No Items Found</div>

    return (
        <div>
            {
                _map(props.listItems, (item: any, index: number) => React.cloneElement(props.renderItem({item, index}), props.commonProps))
            }
        </div>
    )
}

export default FlatList